
import React from "react";
import TopNavbar from "./TopNavbar";
import BottomNavbar from "./BottomNavbar";

const Navbar = () => {
  return (
       <>
       <TopNavbar />
       <BottomNavbar/>
       </>
  );
};

export default Navbar;
